class Player {
    constructor(district, name, car, quiz) {
        this.name = name;
        this.car = car;
        this.playTime = 0;
        this.streaksTriggered = 0;
        this.district = district;
        this.score = 0;
    }

    registerEvents(scene){
        scene.events.on('streak-triggered', ()=>{
            this.streaksTriggered++;
        });
    }

}

export default Player;